import { debounceTime, distinctUntilChanged, scan, catchError } from 'rxjs/operators';
import { EMPTY, OperatorFunction } from 'rxjs';

export function withResetPageOnOtherFilterChange<T extends { page?: number }>(): OperatorFunction<T, T> {
  return source$ => source$.pipe(
    debounceTime(300),
    distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
    scan((acc, curr) => {
      const { page: prevPage, ...prevRest } = acc ?? {};
      const { page: currPage, ...currRest } = curr;

      const otherFieldsChanged = JSON.stringify(prevRest) !== JSON.stringify(currRest);
      return otherFieldsChanged ? { ...curr, page: 0 } : curr;
    }),
    catchError(() => EMPTY)
  );
}
